import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBreakthroughFuelReady extends Layout {
    buttonDownload: Button;
    buttonHold: Button;
    sourceBreakthroughTransaction: DataSource;
    tableBreakthrough: Table;
}
